export enum AugloopRealTimeTranscriptionConnectionKeys {
    OffsetAdjustmentMs = "OffsetAdjustmentMs",
    OnError = "OnError",
    OnFinalResult = "OnFinalResult",
    OnPartialResult = "OnPartialResult",
    OnSpeechEnd = "OnSpeechEnd",
    OnSpeechRecognitionStarted = "OnSpeechRecognitionStarted",
    OnSpeechSessionStarted = "OnSpeechSessionStarted",
    MaxSpeakerId = "MaxSpeakerId",
    AudioDecodingTimeMs = "AudioDecodingTimeMs",
    SpeechSessionId = "SpeechSessionId",
    ReceivedNearRTResult = "ReceivedNearRTResult",
    ResendCount = "ResendCount",
    ResendOffsets = "ResendOffsets",
    SessionEndOffsets = "SessionEndOffsets"
};